import { useQuery } from '@apollo/client/react';
import { useMelwaysInfo } from '@seek/melways-react';

import { LicenceStatus } from 'src/__generated__/graphql';
import { useConfig } from 'src/context/config';

import { GET_LICENCES } from '../graphql/licences.graphql';

export const useQueryLicences = () => {
  const { config } = useConfig();
  const { language } = useMelwaysInfo();
  const {
    data: profile,
    loading,
    error,
  } = useQuery(GET_LICENCES, {
    variables: { languageCode: language, zone: config.ZONE },
  });

  const licences = profile?.viewer?.licences || [];

  const validCertsyLicences = licences
    .filter((licence) => {
      const isExpired = licence.status === LicenceStatus.Expired;
      return !(Boolean(licence?.credential) && isExpired);
    })
    .map(({ verificationUrl, description, credential, ...rest }) => {
      const isVerified = Boolean(credential);
      return {
        ...rest,
        credential,
        description: isVerified ? null : description,
        isVerified,
      };
    });

  return {
    data: {
      licences: validCertsyLicences,
    },
    loading,
    error,
  };
};
